import { SITE } from '@/app/constants';

const GLOBAL_BACKGROUND_URL = 'https://image01.cf.vidu.studio/vidu/media-asset/bg-34b53111.webp';
const CHINA_BACKGROUND_URL = 'https://image01-aliyun.vidu.zone/vidu/media-asset/bg-34b53111.webp';

const BACKGROUND_URL = SITE === 'china' ? CHINA_BACKGROUND_URL : GLOBAL_BACKGROUND_URL;

export function DecorBackground() {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 h-[520px] overflow-hidden sm:h-[360px]">
      <img src={BACKGROUND_URL} alt="" aria-hidden="true" loading="eager" className="h-full w-full object-cover" />
      <div className="absolute inset-x-0 bottom-0 h-52 bg-gradient-to-b from-transparent via-[#05060a]/70 to-[#05060a]" />
    </div>
  );
}
